module.exports = __webpack_public_path__ + "static/beach-d9ae7ef17825f048b6210bfaa3c78a10.jpg";